import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Skeleton,
  Alert
} from '@mui/material';
import { formatPrice } from '../services/bookingService';

const ServiceSelection = ({ services, selectedService, onServiceSelect, loading = false }) => {
  if (loading) {
    return (
      <Box>
        <Typography variant="h6" gutterBottom>
          Select Service
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {[1, 2, 3, 4].map((item) => (
            <Card variant="outlined" key={item} sx={{ width: '100%', borderRadius: 1 }}>
              <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1 }}>
                <Box>
                  <Skeleton variant="text" width={180} height={28} />
                  <Skeleton variant="text" width={120} />
                </Box>
                <Skeleton variant="text" width={60} height={28} />
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    );
  }

  if (!services || services.length === 0) {
    return (
      <Alert severity="info">
        No services available for this clinic. Please contact the clinic directly.
      </Alert>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Select Service
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {services.map((service) => (
          <Card 
            key={service.id}
            variant="outlined"
            sx={{
              width: '100%',
              transition: 'box-shadow 0.2s',
              borderRadius: 1,
              ...(selectedService && selectedService.id === service.id ? {
                borderColor: 'primary.main',
                borderWidth: 2,
                boxShadow: 1
              } : {
                '&:hover': {
                  boxShadow: 1
                }
              })
            }}
          >
            <CardActionArea 
              onClick={() => onServiceSelect(service)}
              sx={{ width: '100%' }}
            >
              <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1 }}>
                <Box>
                  <Typography variant="subtitle1" fontWeight="medium">
                    {service.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Duration: {service.duration_in_minutes} minutes
                  </Typography>
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default ServiceSelection;